/** @jsxImportSource @emotion/react */
import { Text } from "../../../../general/Text";
import { css } from "@emotion/react";
import { modalBodyTextStyle } from "../Approvals.style";
import React from "react";
import { GlobalStore } from "../../../../../store/global/GlobalStore";
import { useAccount } from "wagmi";
import { withIsVisible } from "../../../../../utils/reactUtils";

const MetaMaskTip = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const { connector } = useAccount();
  return (
    <Text
      shouldScale={false}
      size="XL"
      textStyle="Paragraph"
      textCss={css`
        ${modalBodyTextStyle(theme)};
        max-width: 300px;
      `}
      isVisible={connector?.name === "MetaMask"}
    >
      In MetaMask, we recommend selecting{" "}
      <span
        css={css`
          font-weight: 500;
        `}
      >
        Use site suggestion
      </span>{" "}
      as a custom spending cap
    </Text>
  );
};

export default withIsVisible(MetaMaskTip);
